import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/Home';
import AboutPage from './pages/About';
import CoursesPage from './pages/Courses';
import EnrollPage from './pages/Enroll';
import GalleryPage from './pages/Gallery';

/** React Router keeps scroll position across routes; reset it on navigation. */
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);
  return null;
};

const App: React.FC = () => {
  return (
    <div className="app relative min-h-[100dvh] bg-cream">
      {/* Fixed, pointer-events-none: one composite layer, no scroll repaints. */}
      <div className="grain-overlay" aria-hidden="true" />

      <ScrollToTop />
      <Header />

      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/courses" element={<CoursesPage />} />
          <Route path="/enroll" element={<EnrollPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
        </Routes>
      </main>

      <Footer />
    </div>
  );
};

export default App;
